import { atom } from 'recoil'

export default atom({
  key: 'loader',
  default: {
    isLoading: false,
    isMajorLoading: false,
  },
})
